/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Search_HintInputs */

const cs_documents_search_hint = /** @type {(inputs: Documents_Search_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledání vyžaduje alespoň 2 znaky.`)
};

const en_documents_search_hint = /** @type {(inputs: Documents_Search_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search requires at least 2 characters.`)
};

/**
* | output |
* | --- |
* | "Search requires at least 2 characters." |
*
* @param {Documents_Search_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_search_hint = /** @type {((inputs?: Documents_Search_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Search_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_search_hint(inputs)
	return cs_documents_search_hint(inputs)
});